<mat-drawer-container class="example-container" autosize
                      style="background-color:#f3f3f3;font-size: 14px;color: #313131;">

    <app-sidenav></app-sidenav>

</mat-drawer-container>
<!--<notifier-container></notifier-container>-->


